<div [ngClass]="{'darkMode': darkModeService.darkMode,'lightMode': !darkModeService.darkMode}" class="confirm">
  <p>{{ new ? ("ORG_ADMIN.SURE_CREATE" | translate) : ("ORG_ADMIN.SURE_UPDATE"  | translate) }}</p>

  <a routerLink="/v1/status"><button mat-raised-button color="secondary" type="button" *ngIf="new">
      {{ "ORG_ADMIN.CANCEL" | translate }}
    </button></a>

   <button [disabled]="(myForm && !myForm.valid) || !(organization.atLeastOneAdmin )" mat-raised-button color="secondary" (click)="confirmNewOrg()" type="button">
    {{ new ? ("ORG_ADMIN.CREATE" | translate ): ("ORG_ADMIN.UPDATE"  | translate) }}
  </button>
</div>